import type { Team } from "@redotech/redo-team-common/team";
import { isTaskComplete } from "../../registry/helpers";
import type {
  AsyncTaskStatuses,
  SetupProgress,
  SetupTask,
} from "../../registry/types";

export type TaskStatus = "complete" | "dismissed" | "incomplete";

/**
 * Derives the visual status of a task from team + progress state.
 * Pure helper so we can test it without rendering React.
 *
 * Precedence: complete (predicate OR manual) wins over dismissed wins
 * over incomplete. Rationale: a merchant who dismissed a task and then
 * accidentally satisfied its predicate (e.g., enabled billing for
 * unrelated reasons) should see it as done, not "still dismissed."
 */
export function deriveTaskStatus(
  task: SetupTask,
  team: Team,
  progress: SetupProgress,
  asyncTaskStatuses: AsyncTaskStatuses = {},
): TaskStatus {
  if (isTaskComplete(task, team, progress, asyncTaskStatuses)) {
    return "complete";
  }
  if (progress.taskStates[task.id]?.dismissedAt != null) {
    return "dismissed";
  }
  return "incomplete";
}
